const INVERSE_ID_PREFIX = "__inverse__";

const ADD_COLUMN_PREFIX = "__add_column__";

export { ADD_COLUMN_PREFIX, INVERSE_ID_PREFIX };
